import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
  getURLParams
} from '../../helpers';
import _ from 'lodash';

import {
  Aff,
  Saff,
  StatSwitch
} from '../../containers/Filters';
import {
  Datepicker,
  Tops,
} from '../Filters';

import styles from './Filters.module.css';

class Filters extends PureComponent {
  componentDidMount() {
    const params = getURLParams(window.location);
    if (_.isEmpty(params)) {
      this.props.resetFilter(); // clear filters without URL parameters
    }
  };

  render() {
    const {
      defaultDate,
      subs,
      qualityList,
      handleSelect,
      handleSaff,
      handleChange,
      handleSub,
      handleType,
      topsLabel,
      filters,
    } = this.props;

    return (
      <div className={styles.filters}>
        <div className={styles['filters-row']}>
          {!qualityList && <div className={styles['filters-column']}>
            <Datepicker
              defaultDate={defaultDate}
              handleChange={handleChange}
            />
          </div>}
          <div className={styles['filters-column']}>
            <Aff
              qualityList={qualityList}
              handleSelect={handleSelect}
            />
          </div>
          {(subs && !!filters.aff) && handleSaff && (
            <div className={styles['filters-column']}>
              <Saff handleSaff={handleSaff}/>
            </div>
          )}
          {topsLabel && (
            <div className={styles['filters-column']}>
              <Tops handleSub={handleSub} topsLabel={topsLabel}/>
            </div>
          )}
          {handleType && <div className={`${styles['filters-column']} ${styles['filters-column--switch']}`}>
            <StatSwitch handleType={handleType}/>
          </div>}
        </div>
      </div>
    );
  }
}

Filters.propTypes = {
  affList: PropTypes.array,
  saffList: PropTypes.array,
};

Filters.defaultProps = {
  subs: true,
  qualityList: false,
};

export default Filters;
